const mutations = {
  SET_SEDE(state, data) {
    state.sede_data = data;
  },
};

export default mutations;
